"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _gtm = require("./gtm");
Object.keys(_gtm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _gtm[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _gtm[key];
    }
  });
});
var _GtmConfig = require("./types/GtmConfig");
Object.keys(_GtmConfig).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _GtmConfig[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _GtmConfig[key];
    }
  });
});